import React from "react";
import TripForm from "./TripForm";

export default function TripsDiarias() {
    return (
        <TripForm
            tipo="diaria"
            title="Viagens — Diária"
            subtitle="Registro das viagens realizadas por veículos de diária"
        />
    );
}
